/* eslint-disable */
export const adventuring_time = require('./adventuring_time.png');
export const arbalistic = require('./arbalistic.png');
export const avoid_vibration = require('./avoid_vibration.png');
export const blowback = require('./blowback.png');
export const bullseye = require('./bullseye.png');
export const brush_armadillo = require('./brush_armadillo.png');
export const craft_decorated_pot_using_only_sherds = require('./craft_decorated_pot_using_only_sherds.png');
export const crafters_crafting_crafters = require('./crafters_crafting_crafters.png');
export const fall_from_world_height = require('./fall_from_world_height.png');
export const hero_of_the_village = require('./hero_of_the_village.png');
export const honey_block_slide = require('./honey_block_slide.png');
export const kill_a_mob = require('./kill_a_mob.png');
export const kill_all_mobs = require('./kill_all_mobs.png');
export const kill_mob_near_sculk_catalyst = require('./kill_mob_near_sculk_catalyst.png');
export const lighten_up = require('./lighten_up.png');
export const lightning_rod_with_villager_no_fire = require('./lightning_rod_with_villager_no_fire.png');
export const minecraft_trials_edition = require('./minecraft_trials_edition.png');
export const ol_betsy = require('./ol_betsy.png');
export const overoverkill = require('./overoverkill.png');
export const play_jukebox_in_meadows = require('./play_jukebox_in_meadows.png');
export const read_power_of_chiseled_bookshelf = require('./read_power_of_chiseled_bookshelf.png');
export const revaulting = require('./revaulting.png');
export const root = require('./root.png');
export const salvage_sherd = require('./salvage_sherd.png');
export const shoot_arrow = require('./shoot_arrow.png');
export const sleep_in_bed = require('./sleep_in_bed.png');
export const sniper_duel = require('./sniper_duel.png');
export const spyglass_at_dragon = require('./spyglass_at_dragon.png');
export const spyglass_at_ghast = require('./spyglass_at_ghast.png');
export const spyglass_at_parrot = require('./spyglass_at_parrot.png');
export const summon_iron_golem = require('./summon_iron_golem.png');
export const throw_trident = require('./throw_trident.png');
export const totem_of_undying = require('./totem_of_undying.png');
export const trade = require('./trade.png');
export const trade_at_world_height = require('./trade_at_world_height.png');
export const trim_with_all_exclusive_armor_patterns = require('./trim_with_all_exclusive_armor_patterns.png');
export const trim_with_any_armor_pattern = require('./trim_with_any_armor_pattern.png');
export const two_birds_one_arrow = require('./two_birds_one_arrow.png');
export const very_very_frightening = require('./very_very_frightening.png');
export const voluntary_exile = require('./voluntary_exile.png');
export const walk_on_powder_snow_with_leather_boots = require('./walk_on_powder_snow_with_leather_boots.png');
export const who_needs_rockets = require('./who_needs_rockets.png');
export const whos_the_pillager_now = require('./whos_the_pillager_now.png');
export const under_lock_and_key = require('./under_lock_and_key.png');